import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/api-url-helper';
import { CommonService } from 'src/app/services/common/common.service';
import { AddSessionDialogComponent } from '../add-session-dialog/add-session-dialog.component';
import { AddEventDialogComponent } from '../add-event-dialog/add-event-dialog.component';
import { FormControl } from '@angular/forms';
import { customers, dateformat } from 'src/app/models/commonModel';
import { ReplaySubject, Subject, takeUntil } from 'rxjs';
import { MatSelect } from '@angular/material/select';
import { OrderCartDialogComponent } from '../order-cart-dialog/order-cart-dialog.component';

@Component({
    selector: 'app-add-order-dialog',
    templateUrl: './add-order-dialog.component.html',
    styleUrls: ['./add-order-dialog.component.scss'],
    standalone: false
})
export class AddOrderDialogComponent implements OnInit {

  // Common Proprties
  customerList: any = [];
  protected allCustomerlist: customers[] = this.customerList;
  public customerCtrl: FormControl = new FormControl();
  protected filteredCustomer: ReplaySubject<any> = new ReplaySubject();
  @ViewChild('singleSelect', { static: true })
  singleSelect!: MatSelect;
  protected _onDestroy = new Subject();
  selectedCustomerId: any = null;
  selectedCustomerData: any = null;
  currentDay: any;
  dateFormat: any;

  constructor(
    private dialogRef: MatDialogRef<AddOrderDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private commonService: CommonService,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private api: ApiUrlHelper,
    private dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.filteredCustomer.next(this.allCustomerlist.slice());
    this.customerCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {
      this.filterCustomer();
    });
    this.fetchCustomerList();
    this.currentDay = new Date();
    this.dateFormat = dateformat
  }

  ngOnDestroy() {
    this._onDestroy.next(1);
    this._onDestroy.complete();
  }

  cancel() {
    this.dialogRef.close();
  }

  addSession() {
    const dialogRef = this.dialog.open(AddSessionDialogComponent, {
      width: '700px',
      disableClose: true,
      autoFocus: false,
      data: {
        customerId: this.selectedCustomerId,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result == false) {
      }
      else {
        const dialogRef = this.dialog.open(OrderCartDialogComponent, {
          width: '1000px',
          disableClose: true,
          autoFocus: false,
          data: result
        });
        dialogRef.afterClosed().subscribe((result) => {
        });
      }
    })
  }

  addEvent() {
    const dialogRef = this.dialog.open(AddEventDialogComponent, {
      width: '700px',
      disableClose: true,
      autoFocus: false,
      data: {
        customerId: this.selectedCustomerId,
        fromAddOrder: true
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result == false) {
      }
      else {
        const dialogRef = this.dialog.open(OrderCartDialogComponent, {
          width: '1000px',
          disableClose: true,
          autoFocus: false,
          data: result
        });
        dialogRef.afterClosed().subscribe((result) => {
        });
      }
    })
  }

  fetchCustomerList() {
    var api = this.api.apiUrl.Orders.CustomerList;
    this.spinner.show();
    this.commonService.doGet(api).pipe().subscribe({
      next: (response) => {
        if (response.success) {
          this.spinner.hide();
          this.customerList = response.data;
          this.allCustomerlist = response.data.map((item) => ({
            customerId: item.customerId,
            customerName: item.customerName,
            customerAddress: item.customerAddress,
            email: item.email,
            images: item.images
          }));
          this.filterCustomer();
        }
        else {
          this.spinner.hide();
          this.toaster.error(response.message);
        }
      },
      error: (err) => {
        this.spinner.hide();
        console.log(err);
      },
    })
  }

  fetchSelectedCustomerData() {
    let api = this.api.apiUrl.Customer.GetCustomerById.replace('{Id}', this.selectedCustomerId);
    this.spinner.show();
    this.commonService.doGet(api).pipe().subscribe({
      next: (response) => {
        if (response.success) {
          this.spinner.hide();
          this.selectedCustomerData = response.data;
        }
        else {
          this.spinner.hide();
          this.toaster.error(response.message);
        }
      }, error: (err) => {
        this.spinner.hide();
        console.log(err);
      }
    });
  }

  protected filterCustomer() {
    if (!this.allCustomerlist) {
      return;
    }
    let search = this.customerCtrl.value;
    if (!search) {
      this.filteredCustomer.next(this.allCustomerlist.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredCustomer.next(
      this.allCustomerlist.filter(
        (data) => data.customerName.toLowerCase().indexOf(search) > -1
      )
    );
  }

  customerImageHandler() {
    this.selectedCustomerData.images = '../../../assets/img/default-customer-profile.svg';
  }

  customerDropdownImageHandler(customer: any) {
    customer.images = '../../../assets/img/default-customer-profile.svg';
  }
}